import { useQuery } from '@apollo/client/react/hooks';

import DefaultLayout from '~/components/layouts/DefaultLayout';
import { configurationNameForType, configurations } from '~/lib/configuration';

import AccountConnectorAction from './AccountConnectorAction';
import ConnectInterstitial from './ConnectInterstitial';
import query from './query.graphql';

const normalizeIntegrationForAccountConnectorQuery = (integration) => {
  switch (integration) {
    case configurations.salesforce:
    case configurations.pardot:
      return [configurations.salesforce, configurations.salesforcesandbox];
    default:
      return [integration];
  }
};

const ConnectorLayout = ({
  integration,
  children,
  connectorLocation,
  accountConnectorQuery = query,
  ...layoutProps
}) => {
  const { data: { accountConnector = null } = {}, loading, refetch } = useQuery(
    accountConnectorQuery,
    {
      variables: {
        service: normalizeIntegrationForAccountConnectorQuery(integration),
      },
    },
  );

  let childrenRenderFn;
  if (children instanceof Function) {
    childrenRenderFn = children;
  } else {
    childrenRenderFn = () => children;
  }

  layoutProps.shadow = !layoutProps.tabs;

  function accountConnectorIsComplete() {
    if (!accountConnector) {
      return false;
    }

    if (integration === configurations.pardot) {
      return !!accountConnector.pardotBusinessUnitId;
    }

    return true;
  }

  const accountConnectorComplete = accountConnectorIsComplete();

  if (!accountConnectorComplete) {
    layoutProps.shadow = true;
    layoutProps.tabs = null;
  }

  return (
    <DefaultLayout
      loading={loading}
      actions={
        accountConnectorComplete && (
          <AccountConnectorAction accountConnector={accountConnector} />
        )
      }
      background="white"
      title={configurationNameForType(integration)}
      {...layoutProps}>
      {accountConnectorComplete ? (
        childrenRenderFn({ accountConnector })
      ) : (
        <ConnectInterstitial
          integration={integration}
          connectorLocation={connectorLocation}
          onSuccess={() => refetch()}
        />
      )}
    </DefaultLayout>
  );
};

export default ConnectorLayout;
